import { Eyebrow } from "@/components/Eyebrow";
import { ButtonLink } from "@/components/ui/Button";

export function CtaBanner({
  eyebrow,
  body,
  cta,
}: {
  eyebrow: string;
  body: string;
  cta: { label: string; href: string };
}) {
  return (
    <section className="px-8 py-20 md:px-6 md:py-16">
      <div className="mx-auto flex max-w-md flex-col items-center gap-12 text-center md:gap-10">
        <div className="flex flex-col gap-6">
          <Eyebrow>{eyebrow}</Eyebrow>
          <p className="text-sm leading-normal tracking-body text-secondary md:text-base">
            {body}
          </p>
        </div>
        <ButtonLink href={cta.href} variant="outline-brand" size="lg">
          {cta.label}
        </ButtonLink>
      </div>
    </section>
  );
}
